import { updateVariantSlicerVariantChart as updateVariantSlicerVariantChartDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import { Event } from '@process-advisor/process-miner/api/events';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export const updateVariantSlicerVariantChart = ({
    eventEmitter,
}: ApiMethodBase) => {
    const props = updateVariantSlicerVariantChartDiagram();
    eventEmitter.emit(Event.updateVariantSlicerVariantChart, props);
};
